import StudentProfileBox from './StudentProfileBox';

export default StudentProfileBox;
